﻿import {recaptcha} from './recaptcha.directive';
import {RecaptchaService} from './recaptcha.provider';

export default angular.module('idi.core.recaptchaModule', [])
    .directive("recaptcha", recaptcha.factory())
    .provider('recaptchaService', RecaptchaService)
    .name;